module.exports = __webpack_public_path__ + "img/IMG_2524-2.90483974.jpg";